import { render, staticRenderFns } from "./GExamCreateMailSettingDate.vue?vue&type=template&id=7fca53d0&scoped=true&"
import script from "./GExamCreateMailSettingDate.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateMailSettingDate.vue?vue&type=script&lang=ts&"
import style0 from "./GExamCreateMailSettingDate.vue?vue&type=style&index=0&id=7fca53d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca53d0",
  null
  
)

export default component.exports